import styled from "styled-components";
import colors from "../../assets/styles/colors";

export const IdentityValidationContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 20px 15px 20px;
  background: ${colors.bgGray};
`;

export const IdentityValidationWrapper = styled.div``;

export const IdentityValidationHeader = styled.div``;

export const IdentityValidationHeaderTitle = styled.div`
  font-size: 12px;
  color: ${colors.textSecondary};
`;

export const IdentityValidationHeaderArea = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const IdentityValidationContent = styled.div`
  margin-top: 40px;
  display: grid;
  grid-template-columns: 260px 1fr;
`;
